import React from 'react';
import { Information } from '../components';
import { useNavigate, useLocation } from 'react-router-dom';
import { INavigationData } from 'us.collection/interfaces';

interface ICnt_CreditorInfo {
	caseNo: number;
}

const Cnt_CreditorInfo: React.FC<ICnt_CreditorInfo> = (props) => {
	const navigate = useNavigate();
	const location = useLocation();
	const state = location.state as INavigationData;

	const onMinimize = () => {
		navigate(`/case/${props.caseNo}`, { state });
	};

	return <Information onMinimize={onMinimize} />;
};

export default Cnt_CreditorInfo;
